import { createContext, useContext, useEffect, useMemo, useState, createElement } from "react";
import { toast } from "sonner";
import { imgUrl } from "./api";

const CartCtx = createContext(null);
const KEY = "cbls_cart_v1";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const api = useMemo(() => {
    const add = (p, qty = 1) => {
      if (!p?.stock) return toast.error("This part is out of stock");
      setItems((prev) => {
        const found = prev.find((i) => i.id === p.id);
        if (found) return prev.map((i) => (i.id === p.id ? { ...i, qty: Math.min(i.qty + qty, p.stock) } : i));
        return [...prev, { id: p.id, title: p.title, price: p.price, image: imgUrl(p.images?.[0]), stock: p.stock, type: p.airbag_type, qty }];
      });
      toast.success("Added to basket", { description: p.title });
      setOpen(true);
    };
    const setQty = (id, qty) =>
      setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty: Math.max(1, Math.min(qty, i.stock || 20)) } : i)));
    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.qty, 0);
    const total = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { items, add, setQty, remove, clear, count, total, open, setOpen };
  }, [items, open]);

  return createElement(CartCtx.Provider, { value: api }, children);
}

export const useCart = () => useContext(CartCtx);
